import React from 'react';
import RoleButton from './RoleButton';
import LocalStorageService from '../../services/utilities/LocalStorageService';
import { isTargetRoleId } from '../../utilities/roleUtility';
import { USER_ROLES } from '../../utilities/constants';

/**
 * @description 現場監督専用ボタン
 */
const ManagerButton = props => (
  <RoleButton
    label={props.label}
    buttonClass={props.buttonClass}
    onClick={props.onClick}
    show={isTargetRoleId([USER_ROLES.manager], LocalStorageService.getRoleId())}
  />
);

export default ManagerButton;



// WEBPACK FOOTER //
// ./src/components/button/ManagerButton.jsx